<template>
  <div
    :class="{ pointer: !disabled, border: selected }"
    style="width: 36px; height: 36px; border-radius: 4px;align-content: center; "
    :style="{ background: color, opacity: disabled ? 0.35 : 1 }"
    @click="onClick()"
  >
    <div v-if="selected">
      <i class="icon fas fa-check-circle" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Chip',
  components: {},
  props: {
    selected: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      default: '#FF9C9A',
    },
  },
  methods: {
    onClick() {
      if (!this.disabled) {
        this.$emit('selected', this.color);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.text-gray {
  color: #727272;
}

.boder {
  border-right: 1px #b5c3bc solid;
}

.pointer {
  cursor: pointer;
}

.panel-content {
  padding: 24px;
  background: #f7f7f7;
  border-radius: 4px;
}

.text {
  margin-bottom: 5px;
  font-family: Lato;
  font-size: 14px;
  font-weight: 600;
  line-height: 16.8px;
  letter-spacing: -0.005em;
  text-align: left;
}

.icon {
  width: 16px;
  height: 16px;
  color: white;
  margin-left: 8px;
}

.border {
  border: 2px rgba(0, 0, 0, 0.1) solid !important;
}
</style>
